import { XMarkIcon } from "@heroicons/react/24/outline";
import Button from "src/components/form/Button";
import Search from "src/components/form/Search";
import LeftMenuItemGroup from "src/components/navigation/leftNavigation/LeftMenuItemGroup";
import LeftMenuItemLink from "src/components/navigation/leftNavigation/LeftMenuItemLink";
import { outerPages } from "src/config/host";
import { searchMenu } from "src/helpers";
import { classNames } from "src/helpers/classNames";
import useDevice from "src/hooks/useDevice";
import useUrlQueryParams from "src/hooks/useUrlQueryParams";
import CustomHtmlMenu from "../custom/CustomHtmlMenu";

const LeftNavigationMenu = ({
  customSidebarHtml,
  activeNotifications,
  useCustomSidbar,
  mordernDesign,
  isNotification,
  sidepanelWidth,
  isMenu,
  setIsMenu,
  menus = [],
  simulatedMenus = [],
  setSimulatedMenus = () => {},
  keyword = "",
  setKeyword = () => {},
  handleMenuClick = () => {},
}) => {
  const { group: group_id, page: page_id, form: form_id, document: document_id } = useUrlQueryParams();
  // const { site } = useContext(SiteContext);
  const device = useDevice();

  const isOuterPage = outerPages.includes(window.location.href);

  const searchOnMenus = (keyword = "") => {
    if (!keyword) {
      setSimulatedMenus(menus);
    } else {
      setSimulatedMenus(searchMenu(menus, keyword));
    }
  };

  const groupMenus = menus.filter((menu) => menu.type === "group");
  const individualMenus = menus.filter((menu) => menu.type !== "group");

  return (
    <>
      <div
        className={classNames("fixed left-0 top-0 z-[49] block h-full w-screen bg-black transition-all duration-200 xl:z-[39]", mordernDesign ? "!hidden" : "xl:hidden", isMenu ? "visible opacity-80" : "invisible opacity-0")}
        onClick={() => setIsMenu(!isMenu)}></div>
      <div
        className={classNames(
          "flex h-full w-full flex-col bg-white transition-all duration-200",
          useCustomSidbar ? "" : "!bg-leftNavColor",
          mordernDesign
            ? classNames("relative max-h-screen border-black/5 xl:border-b", isNotification ? "xl:max-h-[calc(100vh-13rem)]" : "xl:max-h-[calc(100vh-9rem)]")
            : classNames(!isMenu || isOuterPage ? "-translate-x-full" : "translate-x-0", "fixed left-0 top-0 z-50 shadow-lg xl:absolute xl:z-40"),
        )}
        style={{ maxWidth: device === "desktop" ? sidepanelWidth : 310 }}>
        {isMenu && device === "mobile" && (
          <Button
            buttonIcon={XMarkIcon}
            buttonIconPosition={"right"}
            buttonClasses={"!bg-transparent !absolute top-2 left-full !ml-2 !w-10 !h-10 !px-0 !rounded-full !border-2 !border-white"}
            buttonIconClass={"!w-6 !h-6 !stroke-2"}
            buttonFunction={() => setIsMenu(!isMenu)}
          />
        )}
        {/* <div className={classNames("relative flex flex-shrink-0 items-center !bg-headerColor pl-4", mordernDesign ? "xl:hidden xl:justify-center xl:pl-0" : "h-16 xl:hidden xl:justify-center xl:pl-0")}>
          
          <div className={classNames("h-10", mordernDesign ? "hidden" : "")}>
            <Link
              to={"/login"}
              className="block h-full w-full">
              {!workspace_id || workspaceDetails?.use_global_settings ? (
                site?._id && isLogoVisible ? (
                  <Image
                    src={site?.image_logo ? `${site.image_logo}?${new Date().getTime()}` : Logo}
                    alt={"Logo"}
                    width={"100%"}
                    height={"100%"}
                    effect={"blur"}
                    classes={"object-contain object-left"}
                    hideImageOnError
                  />
                ) : (
                  <></>
                )
              ) : workspaceDetails?._id && isLogoVisible ? (
                <Image
                  src={workspaceDetails?.image_logo ? `${workspaceDetails?.image_logo}?${new Date().getTime()}` : Logo}
                  alt={"Logo"}
                  width={"100%"}
                  height={"100%"}
                  effect={"blur"}
                  classes={"object-contain object-left"}
                  hideImageOnError
                />
              ) : (
                <></>
              )}
            </Link>
          </div>
        </div> */}
        {!useCustomSidbar && groupMenus.reduce((total, group) => (group?.permissions?.length ? total + group?.permissions?.length : total), individualMenus.length) > 15 && (
          <div className={classNames("flex-shrink-0 px-4 pb-2 pt-3")}>
            <Search
              value={keyword}
              placeholder="Search"
              divClasses={classNames("!rounded")}
              onChange={(e) => {
                setKeyword(e.target.value);
                searchOnMenus(e.target.value);
              }}
            />
          </div>
        )}
        {!useCustomSidbar ? (
          <div className={classNames("scrollbar h-full w-full space-y-1 overflow-auto px-4 py-2 pb-10")}>
            <div className="space-y-1">
              {simulatedMenus.map((item) => {
                if (item.type === "group") {
                  return (
                    <LeftMenuItemGroup
                      key={item._id}
                      data={item}
                      group_id={group_id}
                      page_id={page_id || form_id || document_id}
                      searchTerm={keyword ? keyword.toLowerCase() : ""}
                      handleMenuClick={handleMenuClick}
                    />
                  );
                }
                return (
                  <LeftMenuItemLink
                    key={item._id}
                    data={item}
                    image={item?.image}
                    group_id={group_id}
                    page_id={page_id || form_id || document_id}
                    searchTerm={keyword ? keyword.toLowerCase() : ""}
                    handleMenuClick={handleMenuClick}
                  />
                );
              })}
            </div>
          </div>
        ) : (
          <CustomHtmlMenu
            menus={menus}
            sidepanelWidth={sidepanelWidth}
            template={customSidebarHtml}
            isMenu={isMenu}
            activeNotifications={activeNotifications}
          />
        )}
      </div>
    </>
  );
};

export default LeftNavigationMenu;
